import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=21f6408f&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=21f6408f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6408f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f6408f')) {
      api.createRecord('21f6408f', component.options)
    } else {
      api.reload('21f6408f', component.options)
    }
    module.hot.accept("./Drawer.vue?vue&type=template&id=21f6408f&scoped=true", function () {
      api.rerender('21f6408f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/drawer/Drawer.vue"
export default component.exports